import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-panel" }
const _hoisted_2 = {
  key: 0,
  class: "header"
}
const _hoisted_3 = { class: "manage-users-section" }
const _hoisted_4 = { class: "tabs" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.user)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "Manage Customer - UserId: " + _toDisplayString(_ctx.user.userId), 1))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["tab", { active: _ctx.activeTab === tab.name }]),
            onClick: ($event: any) => (_ctx.activeTab = tab.name)
          }, _toDisplayString(tab.label), 11, _hoisted_5))
        }), 128))
      ]),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeComponent)))
    ])
  ]))
}